import { render, staticRenderFns } from "./ReportTabGeneral.vue?vue&type=template&id=7b2f4fd3&scoped=true&lang=pug"
import script from "./ReportTabGeneral.vue?vue&type=script&lang=js"
export * from "./ReportTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./ReportTabGeneral.vue?vue&type=style&index=0&id=7b2f4fd3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f4fd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2f4fd3')) {
      api.createRecord('7b2f4fd3', component.options)
    } else {
      api.reload('7b2f4fd3', component.options)
    }
    module.hot.accept("./ReportTabGeneral.vue?vue&type=template&id=7b2f4fd3&scoped=true&lang=pug", function () {
      api.rerender('7b2f4fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/ReportTabGeneral.vue"
export default component.exports